import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import {
  ManualDispatchCardItem,
  ManualDispatchOverviewResponse,
} from "tng-address-collection-shared/types/apiTypes.ts";
import { queryKeys } from "./queryKeys.ts";

export const useToggleCardManuallySentCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (cardId: string, isSent: boolean) => {
      queryClient.setQueryData<ManualDispatchOverviewResponse>(
        queryKeys.manualDispatchCards(),
        (old) => {
          const oldCard = old?.cards.find((card) => card.id === cardId);
          if (!oldCard) return old;
          const tempCard: ManualDispatchCardItem = {
            ...oldCard,
            manuallySentAt: isSent ? new Date().toISOString() : null,
          };

          const updatedResponse: ManualDispatchOverviewResponse = {
            activatedAt: old?.activatedAt ?? null,
            cards: [
              ...(old?.cards.filter((card) => card.id !== cardId) || []),
              tempCard,
            ],
          };
          return updatedResponse;
        },
      );
    },
    [queryClient],
  );
};

export const useCancelManualDispatchCardsQueries = () => {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      queryClient.cancelQueries({
        queryKey: queryKeys.manualDispatchCards(),
      }),
    [queryClient],
  );
};
